<canvas id="annotCanvas" #canvas [ngStyle]="{'opacity': '0.65', 'width': '100%', 'height': '100%'}"></canvas>